module.exports = __webpack_public_path__ + "static/media/facebook.9ea69f2d.svg";